document.addEventListener('DOMContentLoaded', () => {
  const scrollOffset = 64; // Adjust offset as needed

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    // eslint-disable-next-line func-names
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      // Skip if href is just "#" or empty
      if (!targetId || targetId === '#') return;

      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        e.preventDefault();
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - scrollOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    });
  });
});
